
export const blocks = [
  {
    name: `nyfw`,
    title: `Most Loved Fall/Winter ‘19 Collections: NYFW`,
    blockTitle: `NYC: Oscar de la Renta`,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna. Nunc consectetur lectus sed tortor interdum, quis hendrerit mi vulputate. Integer mattis non nunc at scelerisque. Maecenas dui nisi, hendrerit vel mollis sodales, bibendum ullamcorper massa. In non sodales quam. Nunc neque risus, pretium id bibendum eu, bibendum id lorem. Aenean quis risus sed ex hendrerit tincidunt.`,
    image: require('@/assets/chapters/ch2/1_nyc.jpg'),
    fullResImage: require('@/assets/chapters/ch2/1_nyc.jpg'),
    modalDesc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna.`
  },
  {
    name: `mfw`,
    title: `Most Loved Fall/Winter ‘19 Collections: MFW`,
    blockTitle: `Milan: Prada`,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna. Nunc consectetur lectus sed tortor interdum, quis hendrerit mi vulputate. Integer mattis non nunc at scelerisque. Maecenas dui nisi, hendrerit vel mollis sodales, bibendum ullamcorper massa. In non sodales quam. Nunc neque risus, pretium id bibendum eu, bibendum id lorem. Aenean quis risus sed ex hendrerit tincidunt.`,
    image: require('@/assets/chapters/ch2/2_mil.jpg'),
    fullResImage: require('@/assets/chapters/ch2/2_mil.jpg'),
    modalDesc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna.`
  },
  {
    name: `pfw`,
    title: `Most Loved Fall/Winter ‘19 Collections: PFW`,
    blockTitle: `Paris: Jacquemus`,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna. Nunc consectetur lectus sed tortor interdum, quis hendrerit mi vulputate. Integer mattis non nunc at scelerisque. Maecenas dui nisi, hendrerit vel mollis sodales, bibendum ullamcorper massa. In non sodales quam. Nunc neque risus, pretium id bibendum eu, bibendum id lorem. Aenean quis risus sed ex hendrerit tincidunt.`,
    image: require('@/assets/chapters/ch2/3_par.jpg'),
    fullResImage: require('@/assets/chapters/ch2/3_par.jpg')
  },
  {
    name: `lfw`,
    title: `Most Loved Fall/Winter ‘19 Collections: LFW`,
    blockTitle: `London: Victoria Beckham`,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras lectus magna, gravida id malesuada non, sollicitudin quis urna. Nunc consectetur lectus sed tortor interdum, quis hendrerit mi vulputate. Integer mattis non nunc at scelerisque. Maecenas dui nisi, hendrerit vel mollis sodales, bibendum ullamcorper massa. In non sodales quam. Nunc neque risus, pretium id bibendum eu, bibendum id lorem. Aenean quis risus sed ex hendrerit tincidunt.`,
    blockContent: `lfw`,
    image: require('@/assets/chapters/ch2/4_lnd.jpg'),
    fullResImage: require('@/assets/chapters/ch2/4_lnd.jpg')
  }
]

export default blocks
